import { filter } from 'lodash';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Typography
} from '@material-ui/core';

import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { ClientListHead } from '../_dashboard/clients';
import { baseUrl } from '../../utils/constants';
import { useSettingContext } from '../../context/setting_context';

const TABLE_HEAD = [
  { id: 'settingName', label: 'Setting Name', alignRight: false },
  { id: 'settingValue', label: 'Setting Value', alignRight: false },
  { id: 'settingDescription', label: 'Setting Description', alignRight: false },
  { id: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function EnterpriseSettingsList() {
  const { settingType, settingName } = useSettingContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [settingsList, setSettingsList] = useState([]);
  const [orderBy, setOrderBy] = useState('settingName');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);

  useEffect(() => {
    populateSettingListData();
    console.log('list enterprise', settingsList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (settingType > -1) {
      populateSettingListData();
      console.log('selected enterprise afters', settingsList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settingType]);

  const populateSettingListData = async () => {
    fetch(`${baseUrl}/api/setting/GetEnterpriseSettingTypes?type=${settingType}`)
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('returned enterprise list 0', result);
          console.log('returned enterprise list 1', result.items);
          setSettingsList(result.settings);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    console.log('inside p', settingsList);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleDocView = (e) => {
    window.open(e.documentPath, '_blank');
  };

  const setVerified = (e) => {
    console.log(e);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - settingsList.length) : 0;

  const filteredSettings = applySortFilter(settingsList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredSettings.length === 0;

  return (
    <Container>
      <Typography variant="subtitle1" gutterBottom>
        {settingName} {settingType}
      </Typography>
      {settingsList.length > 0 && (
        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ClientListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={settingsList.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  // onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredSettings
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      const { description, value, subGroup } = row;
                      // const isItemSelected = selected.indexOf(refId) !== -1;

                      return (
                        <TableRow
                          hover
                          // key={refId}
                          tabIndex={-1}
                          role="checkbox"
                          // selected={isItemSelected}
                          // aria-checked={isItemSelected}
                        >
                          <TableCell padding="checkbox" />
                          <TableCell align="left">{description}</TableCell>
                          <TableCell align="left">{value}</TableCell>
                          <TableCell align="left">{subGroup}</TableCell>
                          <TableCell align="right">
                            <IconButton>
                              <VisibilityIcon
                                sx={{ color: '#03a9f4' }}
                                //   onClick={() => handleDocView({ documentPath })}
                              />
                            </IconButton>
                            <IconButton>
                              <DeleteForeverIcon sx={{ color: '#f50057' }} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[8, 16, 24]}
            component="div"
            count={settingsList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      )}
    </Container>
  );
}
